<div class="w-100" *ngIf="addresses">
    <div class="w-100 d-flex justify-content-between align-items-start partnerAddress" *ngIf="isCompany">
        <single-address [address]="addresses"></single-address>
        <div class="companyLogo w-50 text-right" *ngIf="!hideEdit">
            <partner-picker [(partnerId)]="id" (update)="changeId(id)"></partner-picker>
            <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ addresses.logo }}" alt="Logo" *ngIf="addresses.logo">
        </div>
    </div>
    <div class="w-100 d-flex flex-wrap" *ngIf="!isCompany">
        <div class="card shadow-sm address" [ngStyle]="{'width' : getCardWidth()}">
            <div class="card-body p-1">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-grow-1">
                      <h5 class="card-title text-bold">{{ 'Word.Invoice' | translate }}</h5>
                      <div class="ml-2" *ngIf="options.editable"><i class="fas fa-pencil mb-1"></i></div>
                    </div>
                    <span *ngIf="options.useNotification"><i class="fas fa-envelope"></i></span>
                  </div>
                  <div class="card-text">
                      <single-address [address]="addresses.invoice"></single-address>
                  </div>
            </div>
        </div>
        <div class="card shadow-sm address" [ngStyle]="{'width' : getCardWidth()}">
            <div class="card-body p-1">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-grow-1">
                      <h5 class="card-title text-bold">{{ 'Standard.Customer' | translate }}</h5>
                      <div class="ml-2" *ngIf="options.editable"><i class="fas fa-pencil mb-1"></i></div>
                    </div>
                    <span *ngIf="options.useNotification"><i class="fas fa-envelope"></i></span>
                  </div>
                  <div class="card-text">
                      <single-address [address]="addresses.customer"></single-address>
                  </div>
            </div>
        </div>
        <div class="card shadow-sm address" [ngStyle]="{'width' : getCardWidth()}" *ngIf="!options.hideDelivery">
            <div class="card-body p-1">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-grow-1">
                      <h5 class="card-title text-bold">{{ 'Standard.Delivery' | translate }}</h5>
                      <div class="ml-2" *ngIf="options.editable"><i class="fas fa-pencil mb-1"></i></div>
                    </div>
                    <span *ngIf="options.useNotification"><i class="fas fa-envelope"></i></span>
                  </div>
                  <div class="card-text">
                      <single-address [address]="addresses.delivery"></single-address>
                  </div>
            </div>
        </div>
        <div class="card shadow-sm address" [ngStyle]="{'width' : getCardWidth()}" *ngIf="!options.hideContact">
            <div class="card-body p-1">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-grow-1">
                      <h5 class="card-title text-bold">{{ 'Standard.Contact' | translate }}</h5>
                      <div class="ml-2" *ngIf="options.editable"><i class="fas fa-pencil mb-1"></i></div>
                    </div>
                    <span *ngIf="options.useNotification"><i class="fas fa-envelope"></i></span>
                  </div>
                  <div class="card-text">
                      <single-address [address]="addresses.contact"></single-address>
                  </div>
            </div>
        </div>
    </div>
</div>
